import { markerSource } from "./layers";
import { initialCenter, initialZoom } from "./config";
import { setPopupPosition } from "./popup";
import { clearUrlParams } from "./url";

// Create a SVG element with a use element
export function createSvgElementWithUse(href) {
  const svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  const useElement = document.createElementNS("http://www.w3.org/2000/svg", "use");

  useElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", href);
  svgElement.appendChild(useElement);

  return svgElement;
}

// Get the center of a line string
export function getLineStringCenter(lineString) {
  const coordinates = lineString.getCoordinates();
  const midIndex = Math.floor(coordinates.length / 2);
  return coordinates[midIndex];
}

// Zoom to the extent of a feature
export function zoomToExtent(map, extent) {
  map.getView().fit(extent, {
    padding: [100, 100, 100, 100],
    maxZoom: 10,
  });
}

// Reset the map to its initial state
export function resetMap(map) {
  markerSource.clear();
  map.getView().setCenter(initialCenter);
  map.getView().setZoom(initialZoom);
  setPopupPosition(undefined);
  document.getElementById("search-query").value = "";
  document.getElementById("auto-popup-checkbox").checked = false;
  document.querySelectorAll('#search-filters input[type="checkbox"]:checked').forEach((checkbox) => {
    checkbox.checked = false;
  });
  clearUrlParams();
}